import { render } from "./Component.vue?vue&type=template&id=534831f3&scoped=true"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"

import "./Component.vue?vue&type=style&index=0&id=534831f3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534831f3"]])

export default __exports__